import React from "react";
import { CheckCircle2, Circle, Focus, MinusCircle, X } from "lucide-react";

/**
 * Top bar shown in Focus mode (everything but Goals is hidden via CSS).
 * Offers the "Mark today" cycle and an exit button; Esc also exits.
 */
const FocusBar = ({ todayStatus, onMarkToday, onExit }) => {
  const StatusIcon =
    todayStatus === "done" ? CheckCircle2 : todayStatus === "partial" ? MinusCircle : Circle;
  const label =
    todayStatus === "none"
      ? "Mark today done"
      : todayStatus === "done"
        ? "Mark today partial"
        : "Clear today";
  return (
    <div className="sticky top-14 z-30 mb-4 glass rounded-2xl card-shadow px-4 py-2.5 flex items-center gap-3">
      <Focus className="w-5 h-5 text-cyan-400 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-cyan-100 font-semibold text-sm">Focus mode</div>
        <div className="text-[11px] text-gray-400 truncate">
          Only your goals are shown. Press Esc or F to exit.
        </div>
      </div>
      {todayStatus !== null && (
        <button
          type="button"
          onClick={onMarkToday}
          className="tap px-3 py-2 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-white text-sm font-semibold flex items-center gap-1.5"
        >
          <StatusIcon className="w-4 h-4" />
          {label}
        </button>
      )}
      <button
        type="button"
        onClick={onExit}
        className="tap p-2 rounded-xl text-gray-400 hover:text-cyan-300 hover:bg-gray-700/60"
        aria-label="Exit focus mode"
        title="Exit focus mode (Esc)"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};

export default FocusBar;
